import React, { ReactElement } from 'react';

import styled from 'styled-components';
import { ClaimFlowType } from 'types';

import { StyledButton } from 'chime-ui/components/Button';
import { Title } from 'chime-ui/components/Typography';

import LandingBase from 'components/SubPages/Landing/LandingBase';

import { useUserContext } from 'hooks/useUserContext';

import ReceiveFromAnyoneValueProps from './ReceiveFromAnyoneValueProps';
import useReceiveFromAnyoneLandingPage from './useReceiveFromAnyoneLandingPage';

function ReceiveFromAnyoneLanding(): ReactElement {
  const [userData] = useUserContext();
  const { name, amount } = userData;
  const { onCtaClickDebit } = useReceiveFromAnyoneLandingPage();

  return (
    <LandingBase
      pageLocation={'Request Payment Landing Page'}
      claimFlowType={ClaimFlowType.receive}
      landingTitle={
        <Title size={'large'}>
          Pay {name} ${amount}
        </Title>
      }
      showHeaderLogin={false}
    >
      <CTALayout>
        <PrimaryButton onClick={onCtaClickDebit}>
          Pay with your debit card
        </PrimaryButton>
      </CTALayout>
      <ReceiveFromAnyoneValueProps />
    </LandingBase>
  );
}
const CTALayout = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  position: relative;
  bottom: 0;
`;

const PrimaryButton = styled(StyledButton)`
  box-shadow: 0 4px 12px rgba(51, 51, 51, 0.16);
  position: relative;
  height: auto;
`;

export default ReceiveFromAnyoneLanding;
